// Braeside brand assets
export const BRAESIDE_LOGO_URL =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_service-site-planner/artifacts/amx6990w_logo.png";
